/**
 * tetris_say - AI Agent 自言自语工具
 * 让 agent 可以把思考过程发送到页面显示
 */
/* eslint-disable */
var t = require('../lang').t;

// 消息队列存储
if (!window.__tetrisMessages) {
    window.__tetrisMessages = [];
}

// 最大消息数量
var MAX_MESSAGES = 5;

// 上一条消息时间
var lastMessageTime = 0;

// 最小消息间隔（毫秒）
var MIN_INTERVAL = 1000;

/**
 * 发送自言自语消息
 * @param {string} message - 要显示的消息文本
 * @returns {object} 执行结果
 */
function executeSay(message) {
    if (!message || typeof message !== 'string') {
        return {
            success: false,
            error: t('消息不能为空', 'Message cannot be empty')
        };
    }

    // 限制消息长度
    if (message.length > 100) {
        message = message.substring(0, 97) + '...';
    }

    var now = Date.now();

    // 频率限制：1秒1条
    if (now - lastMessageTime < MIN_INTERVAL) {
        return {
            success: false,
            error: t('发送太频繁，请稍后再试', 'Sending too frequently, please retry later')
        };
    }

    lastMessageTime = now;

    // 添加消息到队列
    window.__tetrisMessages.push({
        text: message,
        time: now
    });

    // 保持队列大小
    if (window.__tetrisMessages.length > MAX_MESSAGES) {
        window.__tetrisMessages.shift();
    }

    // 触发更新事件
    if (window.__tetrisMessageCallback) {
        window.__tetrisMessageCallback(message);
    }

    return {
        success: true,
        message: message
    };
}

/**
 * WebMCP 工具定义
 */
module.exports = {
    name: 'tetris_say',
    description: t('AI Agent 自言自语，把思考过程发送到页面显示。强烈推荐使用！让观赏AI打游戏更有趣味。', 'AI Agent speaks to itself, showing its thinking on the page. Highly recommended! Makes watching the AI play more fun.'),
    inputSchema: {
        type: 'object',
        properties: {
            message: {
                type: 'string',
                description: t('要显示的思考内容（不超过100字，频率限制1秒1条）', 'Thinking content to display (max 100 chars, 1 per second)')
            }
        },
        required: ['message']
    },
    execute: function(args) {
        var result = executeSay(args.message);
        return Promise.resolve({
            content: [{
                type: 'text',
                text: JSON.stringify(result, null, 2)
            }]
        });
    }
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/say.js